type SortableColumn = {
  isSortable: true
  sortByPropertyName: string
}
type NonSortableColumn = {
  isSortable: false
}
type TableColumnConfig = {
  id: string

  title: string
  titleAlignment?: 'left' | 'center' | 'right' | undefined
} & (SortableColumn | NonSortableColumn)

export const CurateTableColumnConfigs: TableColumnConfig[] = [
  {
    id: 'select',
    title: 'Select',
    titleAlignment: 'center',
    isSortable: false,
  },
  {
    id: 'thumbnail',
    title: '',
    isSortable: false,
  },
  {
    id: 'contributor',
    title: 'Contributor',
    isSortable: true,
    sortByPropertyName: 'contributor',
  },
  {
    id: 'expandSpacer',
    title: '',
    isSortable: false,
  },
  {
    id: 'uploadDate',
    title: 'Uploaded',
    titleAlignment: 'right',
    isSortable: true,
    sortByPropertyName: 'createdAt',
  },
  {
    id: 'duration',
    title: 'Duration',
    titleAlignment: 'right',
    isSortable: true,
    sortByPropertyName: 'duration',
  },
  {
    id: 'votes',
    title: 'Votes',
    titleAlignment: 'right',
    isSortable: true,
    sortByPropertyName: 'voteCount',
  },
  {
    id: 'isFeatured',
    title: 'Features',
    titleAlignment: 'center',
    isSortable: false,
  },
  {
    id: 'isFavorite',
    title: 'Favorite',
    titleAlignment: 'center',
    isSortable: true,
    sortByPropertyName: 'isFavorite',
  },
  {
    id: 'clipsCount',
    title: 'Clips',
    isSortable: false,
  },
  {
    id: 'isLinked',
    title: 'Linked',
    titleAlignment: 'center',
    isSortable: false,
  },
]
